import version from "../version";

export default function VersionFooter() {
  return (
    <div className="fixed bottom-1 w-full text-center text-xs text-black opacity-50 select-none pointer-events-none">
      {version}
    </div>
  );
}
